import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Table } from 'components/Table';
import useTheme from 'hooks/useTheme';
import storage from 'shared/storage';

const isSeriesOwner = (adminTrack) => {
  const user = storage.get('user');
  const type =
    user.ownership.series.length && !user.ownership.tracks.length && adminTrack
      ? true
      : false;
  return type;
};

export const EventsTable = (props) => {
  const {
    events,
    listType,
    renderReadyStatus,
    renderActions,
    renderPayoutStatus,
  } = props;
  const theme = useTheme();
  const { pathname } = useLocation();

  const isAdminEventList = pathname === '/admin/events';

  const adminTrack = pathname.includes('admin-track');

  const columns = [
    ...(renderReadyStatus
      ? [
          {
            label: '',
            key: 'ready_status',
          },
        ]
      : []),
    ...(renderPayoutStatus
      ? [
          {
            label: '',
            key: 'payout_status',
          },
        ]
      : []),
    {
      label: 'Date',
      key: 'fullDate',
    },
    {
      label: 'Event',
      key: 'event',
    },
    ...(listType === 'admin-events'
      ? isAdminEventList
        ? [
            {
              label: 'Track Name',
              key: 'venue',
            },
          ]
        : []
      : [
          {
            label: isSeriesOwner(adminTrack) ? 'Series' : 'Tracks',
            key: 'venue',
          },
        ]),
    ...(listType === 'admin-events'
      ? [
          {
            label: 'On Sale',
            key: 'on_sale_date',
          },
        ]
      : []),
    {
      label: 'Status',
      key: 'status',
    },
    ...(renderActions
      ? [
          {
            label: '',
            key: 'actions',
          },
        ]
      : []),
  ];

  function renderRows(event) {
    const {
      id,
      isMultiDay,
      day,
      date,
      month,
      listDates,
      year,
      name,
      series,
      track,
      sale_start,
      status = '',
    } = event;
    return {
      ...(renderReadyStatus
        ? { ready_status: renderReadyStatus(event) }
        : null),
      ...(renderPayoutStatus
        ? { payout_status: renderPayoutStatus(event) }
        : null),
      fullDate: isMultiDay
        ? `${month.toUpperCase()} ${listDates} - ${year}`
        : `${day} ${date} - ${year}`,
      event: (
        <Link
          style={{
            color: theme.colors.primary,
          }}
          to={
            !isAdminEventList
              ? listType === 'admin-events'
                ? `/admin/events/menu/${id}`
                : `${pathname}/event/${id}`
              : {
                  pathname:
                    listType === 'admin-events'
                      ? `/admin/events/menu/${id}`
                      : `${pathname}/event/${id}`,
                  state: { event: event },
                }
          }
        >
          {name}
        </Link>
      ),
      venue: isAdminEventList
        ? track.name
        : isSeriesOwner()
        ? series.map((item) => item.name)
        : track.name,
      on_sale_date: sale_start
        ? `${
            moment(sale_start, 'MM-DD-YYYY').isBefore(moment(), 'day')
              ? 'Went'
              : 'Goes'
          } on Sale ${moment(sale_start, 'MM-DD-YYYY').format('MMM D, YYYY')}`
        : '',
      status,
      ...(renderActions ? { actions: renderActions(event) } : null),
    };
  }

  return <Table items={events} columns={columns} renderRows={renderRows} />;
};
EventsTable.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  listType: PropTypes.oneOf(['registrations', 'transactions', 'admin-events']),
  renderActions: PropTypes.func,
  renderReadyStatus: PropTypes.func,
};
